import { Link } from 'react-router-dom';
import { heroContent } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20amber%20and%20cream%20tones%2C%20elegant%20geometric%20shapes%20floating%2C%20minimal%20modern%20design%2C%20clean%20professional%20atmosphere%2C%20subtle%20light%20effects%2C%20digital%20technology%20aesthetic%2C%20peaceful%20warm%20ambiance%2C%20high%20quality%20abstract%20composition&width=1920&height=800&seq=hero-bg-yw91&orientation=landscape"
        alt="喑网91 - 值得信赖的综合网络平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>
      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <span className="inline-block px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm text-white/90 text-xs font-medium mb-6 tracking-wide">
            喑网91最新版本已发布
          </span>
          <h1
            className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight"
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            {heroContent.title}
          </h1>
          <p className="text-lg md:text-xl text-white/80 mb-3">
            {heroContent.subtitle}
          </p>
          <p className="text-sm md:text-base text-white/60 max-w-2xl mx-auto mb-8 leading-relaxed">
            {heroContent.description}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/categories"
              className="px-8 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-200 shadow-lg shadow-primary-500/25 whitespace-nowrap"
            >
              {heroContent.ctaPrimary}
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-all duration-200 whitespace-nowrap"
            >
              {heroContent.ctaSecondary}
            </Link>
          </div>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/50 text-2xl"></i>
      </div>
    </section>
  );
}